var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import marked from 'marked';

import Step1 from './UserInfoStep';
import Step2 from './ContactInfoStep';
import Step3 from './SetLimitsStep';
import Step4 from './ConfirmContactInfoStep';
import Step5 from './ActivationStep';
import PropTypes from 'prop-types';

var STEPS = {
  USER_INFORMATION: 1,
  CONTACT_INFORMATION: 2,
  SET_LIMITS: 3,
  CONFIRM_INFORMATION: 4,
  ACTIVATION: 5
};

var SignUp = function (_PureComponent) {
  _inherits(SignUp, _PureComponent);

  function SignUp(props) {
    _classCallCheck(this, SignUp);

    var _this = _possibleConstructorReturn(this, (SignUp.__proto__ || Object.getPrototypeOf(SignUp)).call(this, props));

    _this._generateContent = function () {
      var _this$state = _this.state,
          currentStep = _this$state.currentStep,
          submitData = _this$state.submitData;


      switch (currentStep) {
        case 1:
          return React.createElement(Step1, _extends({}, submitData, _this.props, {
            onSubmitForm: _this._handleSubmitUserInfoAction
          }));
        case 2:
          return React.createElement(Step2, _extends({}, submitData, _this.props, {
            onSubmitForm: _this._handleSubmitContactInfoAction,
            onGoBack: function onGoBack() {
              return _this._handlePreviousStep(STEPS.USER_INFORMATION);
            }
          }));
        case 3:
          return React.createElement(Step3, {
            limitsData: submitData.Limits,
            onShowLimits: function onShowLimits() {
              return _this.setState({ showLimits: true });
            },
            showLimits: _this.state.showLimits,
            jurisdiction: _this.props.jurisdiction,
            handleSetLimits: _this._handleSetLimits,
            onSubmit: _this._handleNextStepAction,
            onGoBack: function onGoBack() {
              return _this._handlePreviousStep(STEPS.CONTACT_INFORMATION);
            },
            currency: submitData.Currency,
            onCancel: _this._handleCancelLimit,
            responsibleGamingData: _this.props.responsibleGamingData,
            mga: _this.props.jurisdiction.toLowerCase() === 'mga'
          });
        case 4:
          return React.createElement(Step4, _extends({}, _this.props, {
            email: submitData.Email,
            phone: submitData.MobilePhoneNumber,
            callingCode: submitData.CallingCode,
            username: submitData.UserName,
            fullname: submitData.FirstName + ' ' + submitData.LastName,
            birthdate: submitData.BirthDate,
            address: submitData.Address1,
            zip: submitData.Zip,
            city: submitData.City,
            country: submitData.Country,
            optins: submitData.optins,
            currency: submitData.Currency,
            gender: submitData.Gender,
            limits: submitData.Limits,
            onSubmitForm: _this._handleConfirmContactInfoAction,
            onGoBack: function onGoBack() {
              return _this.props.jurisdiction === 'uk' || _this.props.jurisdiction === 'mga' ? _this._handlePreviousStep(STEPS.SET_LIMITS) : _this._handlePreviousStep(STEPS.CONTACT_INFORMATION);
            },
            limitsData: submitData.Limits
          }));

        default:
          return React.createElement(Step5, {
            phone: submitData.MobilePhoneNumber,
            onSubmitForm: _this._handleSubmitActivationCodeAction,
            resendActivateCode: _this._handleResendActivateCode
          });
      }
    };

    _this._handleSubmitUserInfoAction = function (data) {
      var MobilePhoneNumber = data.MobilePhoneNumber,
          other = _objectWithoutProperties(data, ['MobilePhoneNumber']);

      MobilePhoneNumber = MobilePhoneNumber.replace(/^0/, '');
      var step1Data = _extends({}, other, {
        MobilePhoneNumber: '' + MobilePhoneNumber
      });

      _this.props.handleSubmitUserInfo(step1Data).then(function () {
        _this.setState({
          submitData: _extends({}, step1Data)
        });
        _this._handleNextStep(STEPS.CONTACT_INFORMATION);
      });
    };

    _this._handleSubmitContactInfoAction = function (data) {
      var year_of_birth = data.year_of_birth,
          month_of_birth = data.month_of_birth,
          day_of_birth = data.day_of_birth,
          others = _objectWithoutProperties(data, ['year_of_birth', 'month_of_birth', 'day_of_birth']);

      var jurisdiction = _this.props.jurisdiction;


      var step2Data = _extends({}, others, {
        BirthDate: year_of_birth + '/' + month_of_birth + '/' + day_of_birth
      });

      _this.props.handleSubmitContactInfo(_extends({}, step2Data)).then(function () {
        _this.setState({
          submitData: _extends({}, _this.state.submitData, step2Data)
        });

        // If UK, we go to next step for setting limits, else we skip that step
        if (jurisdiction === 'uk' || jurisdiction === 'mga') {
          _this._handleNextStep(STEPS.SET_LIMITS);
        } else {
          _this._handleNextStep(STEPS.CONFIRM_INFORMATION);
        }
      });
    };

    _this._handleSetLimits = function (data) {
      var limits = _this.state.submitData.Limits;

      if (!limits) limits = [];

      var limit = limits.find(function (l) {
        return l.Type === data.Type && l.Timespan === data.Timespan;
      });

      // Remove limit that already exists
      if (limit) limits.splice(limits.indexOf(limit), 1);

      // Only allow numbers
      var validAmount = new RegExp('^[0-9]+$');
      if (!validAmount.test(data.Amount)) return null;

      // Add new limit to the array
      limits = [].concat(_toConsumableArray(limits), [data]).map(function (l, k) {
        return _extends({}, l, {
          Id: k,
          Status: 'Active'
        });
      });

      // Update state with new limit
      _this.setState({
        submitData: _extends({}, _this.state.submitData, {
          Limits: limits
        })
      });
    };

    _this._handleCancelLimit = function (id) {
      var submitData = _this.state.submitData;

      var d = submitData.Limits.filter(function (limit) {
        return limit.Id !== id;
      });

      _this.setState({
        submitData: _extends({}, _this.state.submitData, {
          Limits: d
        })
      });
    };

    _this._handleNextStepAction = function (e) {
      e.preventDefault();
      _this._handleNextStep(STEPS.CONFIRM_INFORMATION);
    };

    _this._handleConfirmContactInfoAction = function (step3Data) {
      var _this$state$submitDat = _this.state.submitData,
          MobilePhoneNumber = _this$state$submitDat.MobilePhoneNumber,
          CallingCode = _this$state$submitDat.CallingCode,
          optins = _this$state$submitDat.optins,
          other = _objectWithoutProperties(_this$state$submitDat, ['MobilePhoneNumber', 'CallingCode', 'optins']);

      // Transform provided phone number on confirmation


      step3Data = _extends({}, other, {
        MobilePhoneNumber: '00' + CallingCode + MobilePhoneNumber,
        OptIns: optins ? ['BonusEmails', 'NewsEmails', 'BonusSMSs', 'NewsSMSs', 'Phone'] : []
      });

      _this.props.handleConfirmContactInfo(step3Data).then(function () {
        // If there is an 409 error, start again from step 1
        if (_this.props.signUpError.hasError) {
          _this.setState(function () {
            return {
              currentStep: STEPS.USER_INFORMATION,
              submitData: _extends({}, other)
            };
          });
        } else {
          _this.setState({ submitData: _extends({}, step3Data) });
          _this._handleNextStep(STEPS.ACTIVATION);
        }
      });
    };

    _this._handleSubmitActivationCodeAction = function (data) {
      _this.props.handleSubmitActivationCode(data);
    };

    _this._handleNextStep = function (step) {
      var currentStep = step;
      _this.setState({
        currentStep: currentStep
      });
    };

    _this._handlePreviousStep = function (step) {
      var currentStep = step;
      _this.setState({
        currentStep: currentStep
      });
    };

    _this._handleResendActivateCode = function () {
      _this.props.resendActivationCode(_this.state.submitData.Email);
    };

    _this.state = {
      currentStep: 1,
      submitData: {
        Limits: []
      },
      showLimits: false
    };
    return _this;
  }

  _createClass(SignUp, [{
    key: 'render',
    value: function render() {
      var currentStep = this.state.currentStep;

      var header = this.props['header' + currentStep];
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'signup-step-wrapper' },
          header && header.content && React.createElement('header', {
            dangerouslySetInnerHTML: { __html: marked(header.content) }
          })
        ),
        this._generateContent()
      );
    }

    // User information form


    // Contact information form


    // Game limit setting form


    // Confirm information form


    // Activate account form

  }]);

  return SignUp;
}(PureComponent);

SignUp.propTypes = {
  /** Function that handles the activation of the user */
  handleSubmitActivationCodeAction: PropTypes.func,
  /** Function that handles the confirmation signing the user up */
  handleConfirmContactInfoAction: PropTypes.func,
  /** Function that submits user contact info and updates local state with the new info */
  handleSubmitContactInfoAction: PropTypes.func,
  /** Function that submits user info and updates local state with the new info */
  handleSubmitUserInfoAction: PropTypes.func,
  /** Function that just handles the proceeding to next step */
  handleNextStepAction: PropTypes.func,
  /** Function that handles the cancellation of existing limits */
  handleCancelLimit: PropTypes.func,
  /** Function that handles the setting of user limits */
  handleSetLimits: PropTypes.func
};


export default SignUp;